import React, { FC } from 'react';

import { useContainerWidth } from '../../../../util/responsiveness';
import { useContentContainerContext } from '../../hooks';

import SubHeader from './SubHeader';
import { SubHeaderRowProps, showSubHeaderBreakpoint } from './SubHeaderRow.types';

const SubHeaderRow: FC<SubHeaderRowProps> = ({ children, forceVisibleAtAllBreakpoints }) => {
  const { shouldShowSubHeaderAtAllBreakpoints } = useContentContainerContext();

  const width = useContainerWidth();
  const shouldShowInCurrentWidth = width < showSubHeaderBreakpoint;
  const shouldRender =
    children && (shouldShowInCurrentWidth || forceVisibleAtAllBreakpoints || shouldShowSubHeaderAtAllBreakpoints);

  if (!shouldRender) {
    return null;
  }

  return <SubHeader>{children}</SubHeader>;
};

export default SubHeaderRow;
